export default function FormFieldRating($DOM, classes) {
	const _class     = '.form__field--rating';
	const $container = $(_class);

	if(!$container.length) {
		return false;
	}

	$container.find('li').hover(function(){
		rate($(this).index(), classes.Hover)
	}, function() {
		$container.find('li').removeClass(classes.Hover);
	});

	$container.find('a').click(function(event) {
		event.preventDefault();

		const $this = $(this);
		const _index = $this.parent().index();

		rate(_index, classes.Active);
		setValue(_index+1);
	});

	function rate(_index, _classes) {
		$container.find('li').each(function(i) {
			$(this).toggleClass(_classes, (i <= _index));
		});
	}

	function setValue(_index) {
		$container.find('input').attr('value', _index);
	}
}